import type {FirebaseOptions} from 'firebase/app'

export type FirebaseEnvironment = Pick<ImportMetaEnv,
  'VITE_USE_EMULATOR' | 'VITE_FIREBASE_API_KEY' | 'VITE_FIREBASE_AUTH_DOMAIN' |
  'VITE_FIREBASE_DATABASE_URL' | 'VITE_FIREBASE_PROJECT_ID' | 'VITE_FIREBASE_STORAGE_BUCKET' |
  'VITE_FIREBASE_MESSAGING_SENDER_ID' | 'VITE_FIREBASE_APP_ID' | 'VITE_FIREBASE_MEASUREMENT_ID'>

export function firebaseClientSettings(environment: FirebaseEnvironment): {options: FirebaseOptions; name: string; useEmulators: boolean} {
  if (environment.VITE_USE_EMULATOR === 'true') {
    const projectId = 'demo-blinds-schedule'
    return {
      useEmulators: true,
      name: 'blinds-demo-emulator',
      options: {
        projectId,
        apiKey: 'demo-api-key',
        authDomain: `${projectId}.firebaseapp.com`,
        storageBucket: `${projectId}.appspot.com`,
        appId: '1:123456789:web:demo',
        messagingSenderId: '123456789',
      },
    }
  }
  return {
    useEmulators: false,
    name: '[DEFAULT]',
    options: {
      apiKey: environment.VITE_FIREBASE_API_KEY,
      authDomain: environment.VITE_FIREBASE_AUTH_DOMAIN,
      databaseURL: environment.VITE_FIREBASE_DATABASE_URL,
      projectId: environment.VITE_FIREBASE_PROJECT_ID,
      storageBucket: environment.VITE_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: environment.VITE_FIREBASE_MESSAGING_SENDER_ID,
      appId: environment.VITE_FIREBASE_APP_ID,
      measurementId: environment.VITE_FIREBASE_MEASUREMENT_ID,
    },
  }
}
